import React from 'react'
import { createRoot } from "react-dom/client"

import '@maxhub/max-ui/dist/styles.css'
import './kit-playground.css'

import { KitPlayground } from "./KitPlayground"

function mountKitPlaygrounds(){
  document.querySelectorAll('[data-kit-playground]').forEach((node) => {
    if (node.dataset.mounted === 'true') return

    const component = node.dataset.component

    if(!component){
      console.error('[KitPlayground] Missing data-component',node)
      return
    }

    node.dataset.mounted = 'true'

    createRoot(node).render(
      <React.StrictMode>
        <KitPlayground component={component}/>
      </React.StrictMode>
    )
  })
} 

if(document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountKitPlaygrounds)
} else{
  mountKitPlaygrounds()
}